import Vue from "vue";
import VueRouter from "vue-router";
import Portal from "@/views/Portal.vue";
import Logout from "@/views/Logout.vue";
import Fail from "@/views/Fail.vue";
import QrCode from "@/views/QrCode.vue";

//Authentication service
import {
  logout, 
  getTokenFromCode,
  getRoles,
  saveAccessToken,
  saveRefreshToken
} from "@/components/auth/AuthService.js"

import {
  NikitaPortalUrlFunct,
  redirectState
} from "@/UrlService.js"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: { name: 'portal' },
  },
  {
    path: "/portal",
    name: "portal",
    component: Portal,
    meta: {
      layout: "MainLayout" 
    }
  },

  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      layout: "SimpleLayout" 
    }
  },
  {
    path: "/fail",
    name: "fail",
    component: Fail,
    meta: {
      layout: "SimpleLayout" 
    }
  },
  {
    path: "/qrcode",
    name: "qrcode",
    component: QrCode,
    meta: {
      layout: "SimpleLayout" 
    }
  }
];

const router = new VueRouter({
  routes,
});

//Authetication middleware
router.beforeEach( async (to, from, next) => {

  //If in dedug set token
  if(process.env.NODE_ENV !== 'production'){
    console.log(process.env.NODE_ENV + " mode. Will be used static token!!");
    
    saveAccessToken(
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IkpZaEFjVFBNWl9MWDZEQmxPV1E3SG4wTmVYRSIsImtpZCI6IkpZaEFjVFBNWl9MWDZEQmxPV1E3SG4wTmVYRSJ9.eyJhdWQiOiJhcGk6Ly8yOWNjY2RlMS1jMDBlLTQ4ZDgtYTIzOC0xMDU4OTUwODlkNTIiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC84NmZiOGUxZi0wMmJkLTQ0MzQtOTZhZS1hYTNlZjQ2N2FkYTgvIiwiaWF0IjoxNzU2OTA0MDY5LCJuYmYiOjE3NTY5MDQwNjksImV4cCI6MTc1NjkwODgxMSwiYWNyIjoiMSIsImFpbyI6IkFYUUFpLzhaQUFBQVBDSUJnOUpVb05EUnliTW1Zd2c3bGVYQk5DQWl2YmpUTXBOQ0tsN3R4N3hJVDM5MkhBS2VJQ1dRNTkzcS93YkM2WEJldEpTeWIxWDhnTjNRZVhZRjZHTEt3MGtDdWNxUWJsUnhxK2Y1dEtzUExNZ0w1cjhpSlBkaW40Zk1LenNSS2l6K1p0UzVEZCsxN3VWVjU4eGhlQT09IiwiYW1yIjpbInB3ZCIsInJzYSIsIm1mYSJdLCJhcHBpZCI6IjI5Y2NjZGUxLWMwMGUtNDhkOC1hMjM4LTEwNTg5NTA4OWQ1MiIsImFwcGlkYWNyIjoiMCIsImRldmljZWlkIjoiYmM0MDVmNzYtY2E2Yy00MGYyLTllMDMtMjEzMjI5OTQxYmZiIiwiZmFtaWx5X25hbWUiOiJHYWdnaW8iLCJnaXZlbl9uYW1lIjoiTWFyY28iLCJpcGFkZHIiOiIxNTEuOTUuMTc0LjIxOCIsIm5hbWUiOiJHYWdnaW8gTWFyY28iLCJvaWQiOiJlOTQ1NTUxNC0wZGQ4LTQ0YTgtODEwNS0zYzJkYzgwNzc5NjEiLCJvbnByZW1fc2lkIjoiUy0xLTUtMjEtMTMxMzMxNjUtMjU1ODUxNjY4Ni0xNjA5NzAxNTMxLTU3MzgiLCJwd2RfZXhwIjoiMTEwNTU3NyIsInB3ZF91cmwiOiJodHRwczovL3BvcnRhbC5taWNyb3NvZnRvbmxpbmUuY29tL0NoYW5nZVBhc3N3b3JkLmFzcHgiLCJyaCI6IjEuQVJFQUg0NzdocjBDTkVTV3Jxby05R2V0cU9ITnpDa093TmhJb2pnUVdKVUluVklSQURZUkFBLiIsInNjcCI6InVzZXIucmVhZCIsInNpZCI6IjAwN2Q0ZTM5LTIwODYtMGY5Ni1hYmUyLTU5M2E0NThkZTVkYyIsInN1YiI6IktEX2lPNVdTVUNIX3VCczVCRjg1a2UteW5vZ3JYWURWejlmN3p3R2VwbkUiLCJ0aWQiOiI4NmZiOGUxZi0wMmJkLTQ0MzQtOTZhZS1hYTNlZjQ2N2FkYTgiLCJ1bmlxdWVfbmFtZSI6Im1hcmNvLmdhZ2dpb0B3aW5kdHJlLml0IiwidXBuIjoibWFyY28uZ2FnZ2lvQHdpbmR0cmUuaXQiLCJ1dGkiOiJtd1MxSFlJTUlVVzBhVmRQTXd6UEFBIiwidmVyIjoiMS4wIiwieG1zX2Z0ZCI6InVGaXgyOXYtaHdUMElrLXVOR3VYMVY0R2NaMEhxeExZbDVYOUdOSGVPSU1CWlhWeWIzQmxibTl5ZEdndFpITnRjdyJ9.kc6J-dheHfY82g4FDS_w1gVZFRxwrTHrn6D7-D8JPLbf_mvx5WEsQkJ3zUlQSwmZzcBMHxg3XUI8OXR9tadUYdQQFwhrfM1rZflbfLo6tVJegfZ-xdD4qctkIpCdYcrZWAekCTMMVVcaCvUsb0iZKpNOWyfe6-ZbFuzRtuT05sd4qLIqRZNJCLHoPwtyjlJjZYs_C20avuOHB9OXvurkKTcHGyJ2tG3zf0aVv6SNp5we9iAmDb59JtSlRtUkwlsJLM_6JCOGSiOuZc1PJt0xGQ93y518jkiqFgRt3UK28jO2DpJtu_Ne0hHBlw9Yf-KMW_npGpkI1yCiMdodmk4KLg"
    );

    saveRefreshToken(
      "1.AREAH477hr0CNESWrqo-9GetqOHNzCkOwNhIojgQWJUInVIRADYRAA.AgABAwEAAABVrSpeuWamRam2jAF1XRQEAwDs_wUA9P-FUNI00Ww6lOciCM7hVTCzdENXBXeTVVMSigSj2jpP7-jNYuswmf1OWMKjOVom-pbzFfQwLSL2Bd8NXF6RYHr1f0UnQT7ReZAqXXGXEri4B6FMqNgu-Ih7OtxzltTEopAE6Yl3lfCOQHsY--yL5K9HLnxZQXI522ww7SFGgJtJmM-4cGp-bjj8KCkV-k6_JvoLHq0KJ6jt2Hx03Aw-s4nbyzW02mRSzg0O_qpo7W6ht9Gk1l-tPGcl_vhF-huw0kpUj9CO-pkOoFmFYPbyJnsScQatE6Mc1Sk_DvKaoz8suqbNapnwbAUkzLmOevAoZyhIOHs0UCWmNET1G1CGYo4hYvKrtkvs_e6_KKpk3XGUwvGbQVpDKgKpynhIxZmzwahn22n5p_Q3ANdMrNZO6DprVCXX1Hv_hJ0Wbi3SgYBQv8JmU85-YySNEv4QrW0E2yP60H-rXpuitASYgumjU_pNgTF3T068NeWop9TOk0cVYc_3OsHnM-5Pu330WX9dRrgNjEAml3WbBFY3zIzTQTIfC3KxBll1n7UDTNuM1FrSNxOdne7lQJiQ44VZgLXJFrR96rg7hDj-DYnJstmkDXcgz-fjr6ABEOQDxRfQREEW1YRb7W1ZvpLnu_7Oqa_h5TBNoHKz3GQC08QW9WGjbyOlsAl7_8jrrA-ilrjeUBUrxf3gTcyEgus8IQbWoiziG7yt4BqB-4fCTnaN2w-j7H9yCtW5FCbQ6yKvEGqbVHwxuRsrEvJ624FCEZxuGTb_qWWG7y4UW8ZzR15iRyUB2xhcMbFCFBaLrA5QIbZsXzzxlOtZZWzU9V5O-kWW1ATmMMJXPtacaSWsMyDqRmNy5Ex4Nffm6smTmg64o_Qm7vQEzQrCEfW85fqHqsVG45sksTOoFkn96otDNCGD4pP1bcRbsQrpDupNnHUJJGLw57KmwXkin_XJcge6RcMHJlHq2vu80Oln5z8zwwzxbfwlMF7Rca6qQpobpsr4wUJuvP10cTNh"
    );
  }

  //Always remove roles. They will be reloaded if token is valid
  localStorage.removeItem("roles");

  //Check if url contains code
  var searchParams = new URLSearchParams(window.location.search);
  var access_code =  searchParams.get("code");
   
  if(access_code != null){//Access code found in url. 
    //Exchange code for access token.
    var istoken = await getTokenFromCode(access_code);
    if(istoken === false){
      logout(redirectState())
    }
    
    //Reloading app, roles will be reloaded. Or go to state url
    var state =  searchParams.get("state");
    if(state !== null){
      window.location.replace(atob(state));  
    }else{
      window.location.replace(atob(redirectState()));
    } 
  }
   
  //get roles async
  if(to.name !== "logout" && to.name !== "fail"){
    console.log("role check")
    var rolesResponse = await getRoles(NikitaPortalUrlFunct() + "authenticationController/getRoles")
    console.log("role complete")
    if(rolesResponse === true){
      next() //router ok
    }else{//Fail to load roles

      if(rolesResponse.message.includes("401")){ //unauthorize. Then redirect to authetication endpoint
        logout(redirectState())      
      } else{//Else show fail page
        var errorMessage = JSON.stringify(rolesResponse)
        next({ name: 'fail', query: {errorMessage: errorMessage}})
      }
      
    }
  } else{
    next()
  }
})

export default router;
